import { AxiosError } from "axios";
import { useQuery } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getStudyImagesUrl } from "@src/config/baseUrls";
import { queryKeys } from "@src/config/queryKeys";

const useStudyImages = (studyId?: string, testId?: string) => {
  const axios = useAxios();

  return useQuery<string[], AxiosError>(
    [queryKeys.STUDY_IMAGES, studyId, testId],
    async () => {
      const { data } = await axios.get(
        getStudyImagesUrl(studyId ?? "", testId ?? ""),
      );
      return data;
    },
    { enabled: !!studyId, cacheTime: 0 },
  );
};

export default useStudyImages;
